/**
 * The currency a bill was paid in, for dialogs that hand money back or take
 * more (cancel / add items, QRIPO-543). Every amount the backend returns is in
 * kip; the cashier pays out or collects in the currency the customer used.
 *
 * Expects the component to have a `ticket` (bill_detail) and the NumberFormat
 * filter (myMixin).
 */
export const ticketPaymentCurrency = {
  methods: {
    paymentData() {
      const raw = this.ticket?.payment_data;
      try {
        const data = typeof raw === "string" ? JSON.parse(raw) : raw;
        return data && typeof data === "object" ? data : {};
      } catch (e) {
        return {};
      }
    },
    // Code and rate (kip per unit) at the time of the sale, from the same
    // payment_data the bill detail reads.
    paymentCurrency() {
      const data = this.paymentData();
      let code = data.currency_code;
      let rate = data.exchange_rate;
      if (!code && data.payment_details) {
        try {
          const details =
            typeof data.payment_details === "string"
              ? JSON.parse(data.payment_details)
              : data.payment_details;
          code = details?.currency_code;
          rate = rate || details?.exchange_rate;
        } catch (e) {
          // fall through to kip
        }
      }
      rate = Number(rate || this.ticket?.exchange_rate || 1);
      if (!code || code === "LAK" || !(rate > 0)) {
        return { code: "LAK", rate: 1 };
      }
      return { code, rate };
    },
    // "200.00 THB (100,000 LAK)", or "100,000 LAK" for a kip bill.
    formatInPaidCurrency(amountLak) {
      const { code, rate } = this.paymentCurrency();
      const format = this.$options.filters.NumberFormat;
      if (code === "LAK") return `${format(amountLak)} LAK`;
      return `${format(amountLak / rate)} ${code} (${format(amountLak)} LAK)`;
    },
  },
};
